module.exports = __webpack_public_path__ + "img/news-teo.e718401d.png";